import { render, staticRenderFns } from "./DevBar.vue?vue&type=template&id=34608b42&scoped=true"
import script from "./DevBar.vue?vue&type=script&lang=js"
export * from "./DevBar.vue?vue&type=script&lang=js"
import style0 from "./DevBar.vue?vue&type=style&index=0&id=34608b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34608b42",
  null
  
)

export default component.exports